export async function locateCountry(): Promise<string | undefined> {
  // @ts-expect-error Only works in the browser
  const response = await fetch('https://ip2c.org/s')
  const data = await response.text()
  const [status, countryCode] = data.split(';')
  if (status === '1') {
    return countryCode
  }
}
